export const appointmentData = [
    {
      id: 1,
      patient: "Barry Vermont",
      day: new Date(),
      consulted: true,
      doctor: "Dr. Hazel Valery",
    },
    {
      id: 2,
      patient: "Harry Coming",
      day: new Date(),
      consulted: false,
      doctor: "Dr. Jessica White",
    },
    {
      id: 3,
      patient: "Aaron Black",
      day: new Date(),
      consulted: true,
      doctor: "Dr. Jasmine Carpanter",
    },
  ]
  
  export const doctorData = [
    {
      id: 1,
      name: "Dr.Hazel Valery",
      dep: "Cardiology",
      img: "./img/dr1.jpg",
    },
    {
      id: 2,
      name: "Dr. Jasmine Carpanter",
      dep: "Radiolgy",
      img: "./img/dr2.jpg",
    },
    {
      id: 3,
      name: "Dr. Arianna Mary",
      dep: "Orthopedy",
      img: "./img/dr3.jpg",
    },
    {
      id: 4,
      name: "Dr. Jessica White",
      dep: "Gastroentogoly",
      img: "./img/dr4.jpg",
    },
    {
      id: 5,
      name: "Harry Coming",
      dep: "Surgery",
      img: "./img/dr9.jpg",
    },
    {
      id: 6,
      name: "Dr. Kristensen Abraham",
      dep: "Neurology",
      img: "./img/dr6.jpg",
    },
    {
      id: 7,
      name: "Dr.Asley Graham",
      dep: "Pediatry",
      img: "./img/dr7.jpg",
    },
    {
      id: 8,
      name: "Dr. Mary Motley",
      dep: "Oncology",
      img: "./img/dr8.jpg",
    },
  ]